import { Star } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale';

export interface Comment {
  id: string;
  rating: number;
  review: string;
  date: string;
}

interface CommentListProps {
  comments: Comment[];
}

export default function CommentList({ comments }: CommentListProps) {
  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">{comments.length} comentarios</h2>
      <div className="space-y-4">
        {comments.map((comment) => (
          <div
            key={comment.date}
            className="flex flex-col sm:flex-row justify-between border border-gray-200 rounded-md p-4 bg-white"
          >
            <div className="flex items-start space-x-3">
              <img
                className="rounded-full overflow-hidden w-14 h-14"
                src="https://image.beholos.com/fit-in/100x100/filters:quality(80)/img/userImage.jpg"
                alt="User"
              />
              <div>
                <div className="flex items-center space-x-1 text-sm font-semibold">
                  <Star className="w-4 h-4 fill-black text-black" />
                  <span>{(comment.rating + 1).toFixed(1)}</span>
                </div>
                {comment.review && (
                  <p className="mt-1 text-sm text-gray-800">{comment.review}</p>
                )}
              </div>
            </div>
            <div className="mt-2 sm:mt-0 text-sm text-gray-500">
              hace {formatDistanceToNow(new Date(comment.date), { locale: es })}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
